import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearCloneExperience(): RootActionTypes {
  return {
    type: ActionTypes.CLEAR_CLONE_EXPERIENCE,
  };
}
